<template>
  <div class="setting-account-page">
    <div class="header-title">Apphi Account</div>
    <div class="main-container">
      <div class="email-tip">{{ user.email }}</div>
      <div class="email-message-tip">
        Your email address can be used to sign in to Apphi on the web and in
        apps.
      </div>
      <hi-button
        class="change-password-btn"
        type="text"
        @click.native="changePassword"
      >
        {{ $t("emailPage.changePassword") }}
      </hi-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { CURRENT_USER_INFO_SIMPLE } from "../../store/mutation-types";
import hiButton from "../../components/common/button/Index";

export default {
  name: "SettingDefaultTimePage",
  components: { hiButton },
  computed: {
    ...mapGetters({
      user: CURRENT_USER_INFO_SIMPLE,
    }),
  },
  data() {
    return {};
  },
  methods: {
    changePassword() {
      window.open(process.env.VUE_APP_CHANGE_PASSWORD, "_blank");
    },
  },
};
</script>
<style scoped lang="less">
@import "../../assets/style/theme.less";

.setting-account-page {
  height: 100vh;
  .header-title {
    font-size: 20px;
    height: 80px;
    display: flex;
    align-items: center;
    font-weight: 500;
    padding-left: 20px;
    border-bottom: 1px solid @border-color;
  }
  .main-container {
    padding: 60px;
    .email-tip {
      font-size: 18px;
      font-weight: 500;
    }
    .email-message-tip {
      font-size: 16px;
      color: #5a5a5a;
      margin-top: 20px;
    }
    .change-password-btn {
      height: 40px;
      border-radius: 2px;
      border: solid 1px #e6e6e6;
      font-size: 16px;
      color: #000000;
      padding: 0 30px;
      margin-top: 40px;
    }
  }
}
</style>
